/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for sourceCategoryType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sourceCategoryType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="calculation"/&gt; &lt;enumeration value="column"/&gt; &lt;enumeration value="dimension/measure"/&gt; &lt;enumeration value="dimension/regular"/&gt; &lt;enumeration value="folder"/&gt; &lt;enumeration value="hierarchy/level"/&gt; &lt;enumeration value="hierarchy/parent-child"/&gt; &lt;enumeration value="level"/&gt; &lt;enumeration value="measure"/&gt; &lt;enumeration value="namedSet"/&gt; &lt;enumeration value="property"/&gt; &lt;enumeration value="table"/&gt; &lt;enumeration value="variable"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SourceCategoryType extends Enum{

	enumValue = null;

	static  CALCULATION = SourceCategoryType.newLiteral("calculation");

	static  COLUMN = SourceCategoryType.newLiteral("column");

	static  DIMENSION_MEASURE = SourceCategoryType.newLiteral("dimension/measure");

	static  DIMENSION_REGULAR = SourceCategoryType.newLiteral("dimension/regular");

	static  FOLDER = SourceCategoryType.newLiteral("folder");

	static  HIERARCHY_LEVEL = SourceCategoryType.newLiteral("hierarchy/level");

	static  HIERARCHY_PARENT_CHILD = SourceCategoryType.newLiteral("hierarchy/parent-child");

	static  LEVEL = SourceCategoryType.newLiteral("level");

	static  MEASURE = SourceCategoryType.newLiteral("measure");

	static  NAMED_SET = SourceCategoryType.newLiteral("namedSet");

	static  PROPERTY = SourceCategoryType.newLiteral("property");

	static  TABLE = SourceCategoryType.newLiteral("table");

	static  VARIABLE = SourceCategoryType.newLiteral("variable");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SourceCategoryType.values().length); ++i) {
			if (SourceCategoryType.values()[i].enumValue == v) {
				return SourceCategoryType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SourceCategoryType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SourceCategoryType.js